import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Properties from "../pages/properties/page";
import PropertyDetail from "../pages/properties/detail/page";
import Brochure from "../pages/brochure/page";
import SocialHousing from "../pages/social-housing/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfUse from "../pages/terms-of-use/page";
import RiskDisclaimer from "../pages/risk-disclaimer/page";
import Admin from "../pages/admin/page";
const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/properties", element: <Properties /> },
  { path: "/properties/:id", element: <PropertyDetail /> },
  { path: "/brochure", element: <Brochure /> },
  { path: "/social-housing", element: <SocialHousing /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-of-use", element: <TermsOfUse /> },
  { path: "/risk-disclaimer", element: <RiskDisclaimer /> },
  { path: "/admin", element: <Admin /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
